import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';

interface IProps {
  disabled?: boolean;
  isLoading?: boolean;
  text?: string;
  onClick?: () => void;
}

export const VerFooter = ({ text = 'Continue', isLoading, disabled, onClick }: IProps) => {
  return (
    <div className='w-full px-[16px] mt-[16px] mb-[24px] sm:px-0 z-40 bg-surface-primary-bw-00 sm:block shrink-0 sticky bottom-0 left-0 max-w-[420px] mx-auto'>
      <div className={'w-full flex items-center justify-center'}>
        <div className={'w-full'}>
          <LiliButton
            onClick={onClick}
            isLoading={isLoading}
            disabled={disabled}
            id={'business-verification-center__btn'}
            type={LiliButtonType.PRIMARY}
            title={text}
          />
        </div>
      </div>
    </div>
  );
};
